import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=3582491c&scoped=true"
var script = {}
import style0 from "./TopBar.vue?vue&type=style&index=0&id=3582491c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582491c",
  null
  
)

export default component.exports